import { render, staticRenderFns } from "./CrewFormModal.vue?vue&type=template&id=36d79782&scoped=true"
import script from "./CrewFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewFormModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewFormModal.vue?vue&type=style&index=0&id=36d79782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d79782",
  null
  
)

export default component.exports